<template>
  <div class="home">
      <!--<img src="" width="100%" height="100%" alt="" />-->
    <!-- 弹出框 -->
      <el-dialog :visible.sync="centerDialogVisible3" width="40%" center>
        <div class="dialog_tit" slot="title">学习说明</div>
        <div class="dialog_desc">
          1、在线课程学习总成绩占比{{ rates.studyRate }}%
          <br />
          2、课程练习总成绩占比{{ rates.practiceRate }}%
          <br />
          3、课程考试总成绩占比{{ rates.examRate }}%
          <br />
          4、课程答疑笔记总成绩占比{{ rates.answerRate }}%
          <br />
          <div>
            根据每门课程的总学分不同，按照学习情况，实时转化成学分。
            <br />
            每门课程总成绩达到{{ popup.rate }}及以上即为合格 eg：{{
              popup.title
            }}线上成绩总分{{ popup.total }}分，
            <br />
            （在线课程学习+课程练习+课程考试+答疑笔记）≥{{
              popup.rate
            }}，合格。否则不合格
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <div @click="centerDialogVisible3 = false">确定</div>
        </span>
      </el-dialog>
    <el-dialog v-if="schoolInfo.id == 36 && userInfo.gradeName == '2026级 '" :visible.sync="centerDialogVisible9" width="320px"  center>
      <div class="dialog_tit" style="height: 124px;" slot="title">学习平台付款码
        <div>
          <div class="dialog_desc">

          </div>
          <img
              class="gender"
              src="../assets/img/home/pay.jpg"
              style="margin-top:-10px;width: 320px; height: 400px; float: left!important;"
          />
          <div >
            <p class="large-text">付款时务必正确填写姓名和身份证号，付款成功即可待后台审核</p>
          </div>

        </div>

      </div>
    </el-dialog>
<!--    <BayWindow/>-->
    <div class="content_box">
        <!-- 公告 -->
        <Msg :lists="lists"></Msg>
        <div class="headers-img" style="z-index: 888">
            <!--    <div class="table-container" style="padding-top: 40px;margin-left: 15px; margin-right: 15px;">
                    <span style="font-size: 20px;margin-bottom: 10px">通知公告</span>
                    <el-table :data="noticeList.slice(0, 4)" size="mini" fit element-loading-text="Loading" border
                              highlight-current-row align="center" style="font-size: 18px;" @row-click="toMag">
                        <el-table-column label="序号" type="index" align="center" min-width="10%"></el-table-column>
                        <el-table-column label="通知" prop="title" align="center"></el-table-column>
                        <el-table-column label="发布时间" prop="addtime" :formatter="dateFormat" align="center"
                                         min-width="25%"></el-table-column>
                    </el-table>
                </div>   box-shadow: 0 2px 12px 0 #f85415;-->

            <el-row :gutter="40" style="width: 100%;">
                <el-col :xs="24" :sm="24" :lg="8">
                    <div class="row_style" style="padding-top: 35px;
        padding-right: 0px;
        padding-bottom: 30px;
        padding-left: 0px; border-radius: 30px; width: 380px;height: 350px; background-color: #fff;">
                        <div class="personal_tit" style="
          font-size: 20px;
          padding-left: 10px;
          ">
                            <span style="color:#778899"> 我的资料</span>
                        </div>
                        <div class="personal_body" style="padding-left: 10px;">
                            <!--style="broder-radius:2px;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)"-->
                            <div class="personal_body_top">
                                <div class="per_bd_left">
                                    <div class="txImg">
                                        <!--<img src="../assets/img/home/img8.png" style="width: 105px; height: 105px;" />-->
                                        <div v-if="parseInt(userInfo.sex) == 1">
                                            <!--<div class="name" style="padding-top: 15px;font-size: 20px;">{{ userInfo.username }}</div>-->
                                            <img
                                                    class="gender"
                                                    src="../assets/img/home/girl.jpg"
                                                    style="margin-top:15px;width: 105px; height: 105px; float: left!important;"
                                            />
                                        </div>

                                        <div v-else>

                                            <img
                                                    class="gender"
                                                    src="../assets/img/home/boy.jpg"
                                                    style="margin-top:15px;width: 105px; height: 105px;float: left!important;"
                                            />
                                        </div>
                                    </div>
                                    <div class="name"
                                         style="padding-top: 30px; padding-left: 120px; font-size: 24px;color:#778899">
                                        {{ userInfo.trueName }}
                                    </div>
                                    <br/>
                                    <br/>
                                    <div style="padding-left: 120px;">
                                        <el-button type="success" @click="$router.push('/study')" round style="display: inline-block;
                    padding: 0 15px;
                    height: 25px;
                    line-height: 25px;
                    font-size: 16px;
                    color: #fff;
                    border-radius: 15px;">我的课程</el-button>
                                        <el-button type="warning" @click="$router.push('/test')" round style="display: inline-block;
                    padding: 0 15px;
                    height: 25px;
                    line-height: 25px;
                    font-size: 16px;
                    color: #fff;
                    border-radius: 15px;">考试练习</el-button>
                                    </div>
                                    <div class="info_box" style="padding-top: 50px;
                  padding-right: 0px;
                  padding-bottom: 0px;
                  padding-left: 10px;">
                                        <div style="font-size: 18px;">
                                            <span style="color:#778899	"> 账号： </span>

                                            <span style="font-size: 16px;color:#778899"> {{ userInfo.username }}</span>
                                        </div>
                                        <div style="font-size: 18px;">
                                            <span style="color:#778899	"> 层次： </span>
                                            <span style="font-size: 16px;color:#778899">{{ userInfo.levelName }}</span>

                                        </div>
                                        <div style="font-size: 18px;">
                                            <span style="color:#778899	"> 专业： </span>
                                            <span style="font-size: 16px;color:#778899">{{ userInfo.majorName }}</span>

                                        </div>
                                        <div style="font-size: 18px;">
                                            <span style="color:#778899	"> 年级：</span>
                                            <span style="font-size: 16px;color:#778899">
                      {{ userInfo.gradeName }}
                    </span>

                                            <div style="font-size: 18px;">
                                                <span style="color:#778899	">  学号：</span>

                                                <span style="font-size: 16px;color:#778899">
                      {{ userInfo.stuNum }}
                    </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--<div class="info_tips">
                              毕业要求：各门课及格分值为65%，五个学期不挂科即为合格 准许毕业~
                            </div>-->
                        </div>
                    </div>

                </el-col>


                <el-col :xs="24" :sm="24" :lg="8">
                    <div style="padding-top: 35px;border-radius: 30px; width: 380px;height: 380px;background-color: #fff; ">
                        <PieChart :terms="terms" style="margin-top: 30px;" v-if="terms.length > 0"/>
                    </div>
                    <!--<div style="padding-top: 35px;border-radius: 30px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);width: 380px;height: 380px;background-color: #fff; ">
                      <div class="nowTerm" style=" display: flex;
                      justify-content: space-between;
                      align-items: center;
                      margin-bottom: 20px; " >

                        <div class="learnState1" @click="centerDialogVisible = true">
                          &lt;!&ndash;<div>说明</div>&ndash;&gt;
                            <span style="padding-left: 10px;font-size: 15px; color:#778899" >当前学期：{{ Now.name }}（{{
                            (Now.beginTime * 1000) | dateFormat
                            }}-{{ (Now.endTime * 1000) | dateFormat }}）</span>

                            <img src="../assets/img/home/icon-5.png"  style="width: 15px; height: 15px"/>
                        </div>
                      </div>
                      <div id="myChart" :style="{ width: '350px', height: '330px' }"></div>
                    </div>-->


                </el-col>
                <el-col :xs="24" :sm="24" :lg="8">
                    <div class="msg_box1"
                         style="padding-top: 35px; border-radius: 30px; width: 380px;height: 380px;background-color: #fff;">
                        <div class="plan_top1">
                            <div style="font-size: 20px;
                padding-left: 10px;color:#778899">学院简介
                                <a :href="ecode" target="_blank"
                                   style="margin-right:15px;float: right!important;color:#767676;"><span style="font-size: 14px;">更多..</span></a>
                            </div>
                            <div style="    line-height: 24px;
              font-size: 16px;
              color: #666;
              text-indent: 2em; margin-left: 15px; margin-right: 15px; margin-top: 30px; margin-bottom: 5px; overflow:hidden;text-overflow: ellipsis;-webkit-line-clamp:12; display: -webkit-box;-webkit-box-orient: vertical;"
                                 v-html="schoolInfo.frontIntro">
                            </div>


                        </div>

                    </div>
                </el-col>

      </el-row>
        </div>

      <!-- 教学计划 -->
        <div class="plan">
        <div class="plan_top">
          <div>教学计划</div>
          <div
            :class="{ active: more == 0 }"
            @mouseenter="more = 0"
            @mouseleave="more = -1"
          >
            <!-- 查看更多 -->
          </div>
        </div>
        <div class="plan_body">
            <!-- tabs切换 学期-->
          <div class="plan_tabs">
            <div
              class="tabsitem"
              v-for="(item, index) in semesterList"
              :key="index"
              :class="{ active2: active2 == index }"
              @click="changeTabs(index)"
            >
              <div>
                {{ item.name }}
              </div>

            </div>
          </div>
            <div>
                学习时间：
                {{ (this.start_time * 1000) | dateFormat }} ～ {{
                (this.end_time * 1000) | dateFormat
                }}
                <div @click="centerDialogVisible3 = true"
                     style="display:inline-block;margin-left:10px; margin-top: 5px; color: blue; background-color: #ff6829;-webkit-border-radius: 50px;-moz-border-radius: 50px;border-radius: 50px;">
                    学习说明
                </div>
                <!--<img  src="../assets/img/home/question.png"-->
                <!--style="margin-left:10px; margin-top: 5px; width: 25px; height: 25px"/>-->
          </div>
            <div class="plan_list" style="display: block;">
            <div
                    class="list_box"
                    v-for="(item3, index3) in courses"
                    :key="index3"
            >

              <div class="list_right">
                  <img class="listImg" :src="item3.img" alt/>
                  <div class="list_tit">

                      <span class="t">{{ item3.name }}</span>
                      <div class="b">
                          <div v-if="item3.ssTime ==0 && item3.examStatus!=1">
                              <span style="font-size: 16px;">考试时间：暂未安排</span>
                          </div>
<!--                        有补考状态，说明已有考试，且已经过考试-->
<!--                          <div v-if="item3.ssTime !=0 && item3.examStatus==0">-->
                          <div v-else-if="item3.examStatus!=1">
                              <span style="font-size: 16px;">考试时间： {{ (item3.ssTime * 1000) | dateFormat }} ～ {{(item3.eeTime * 1000) | dateFormat }}</span>
                          </div>
                          <div v-else-if="(new Date().getTime() > item3.eeTime * 1000)  && item3.examStatus==1">
                                <span style="font-size: 16px;">补考时间：{{ (item3.ssTimeB * 1000) | dateFormat }} ～ {{(item3.eeTimeB * 1000) | dateFormat }}</span>
                          </div>
                      </div>
                      <p class="score">
                        <span style="font-size: 16px;">学习进度：
                        </span>
                          <el-progress :text-inside="true" :stroke-width="22" status="success"
                                       :percentage=" item3.videos==0?0:parseInt(item3.learn/ item3.videos * 100)"></el-progress>
                      </p>

                  </div>
                  <div class="study">
                      <div>
                          <div v-if="item3.btn == 2" class="list_btn list_btn_n">
                              已结束
                          </div>
                          <div v-else-if="item3.btn == 0" class="list_btn list_btn_n1">
                              未开始
                          </div>
                          <div
                                  v-else-if="item3.is_pass == 1 && item3.btn == 1"
                                  class="list_btn"
                          >
                              已完成
                          </div>
                          <div v-else-if="item3.name == '毕业设计' || item3.name == '毕业论文（设计）'" class="list_btn list_btn_n1">
                              开始学习
                          </div>
                          <div
                                  v-else-if="item3.is_pass == 0 && item3.btn == 1"
                                  class="list_btn2"
                                  @click="toVideo(item3.id)"
                                  :class="{ current: current == index3 }"
                                  @mouseenter="current = index3"
                                  @mouseleave="current = -1"
                          >
                              开始学习
                          </div>


                      </div>

                      <div>
                          <div v-if="item3.btn == 2" class="list_btn list_btn_n">
                              已结束
                          </div>
                          <div v-else-if="item3.btn == 0" class="list_btn list_btn_n1">
                              未开始
                          </div>
                          <div
                                  v-else-if="item3.is_pass == 1 && item3.btn == 1"
                                  class="list_btn"
                          >
                              已完成
                          </div>
                          <div v-else-if="item3.name == '毕业设计' || item3.name == '毕业论文（设计）'" class="list_btn list_btn_n1">
                            课堂练习
                          </div>
                          <div
                                  v-else-if="item3.is_pass == 0 && item3.btn == 1"
                                  class="list_btn2"
                                  @click="toPractice(item3.id)"
                                  :class="{ current2: current2 == index3 }"
                                  @mouseenter="current2 = index3"
                                  @mouseleave="current2 = -1"
                          >
                              课堂练习
                          </div>
                      </div>

<!--                    item3.is_pass 未通过-->
<!--                    item3.is_pass 考试时间结束-->
<!--                    item3.is_pass 已设置补考-->
                      <div>
<!--                          <div-->
<!--                              v-if="item3.is_pass == 1 && item3.btn == 1 && new Date().getTime() < item3.eeTime * 1000"-->
<!--                              class="list_btn"-->
<!--                          >-->
<!--                            已通过-->
<!--                          </div>-->
                          <div
                              v-if="item3.is_pass == 1 && item3.btn == 1 "
                              class="list_btn"
                          >
                            已通过
                          </div>
                          <div v-else-if="new Date().getTime() >= item3.eeTime * 1000 && item3.eeTime != 0 && item3.examStatus!=1"
                               class="list_btn list_btn_n">
                              已结束
                          </div>
                          <div v-else-if="new Date().getTime() >= item3.eeTimeB * 1000 && item3.eeTimeB != 0 && item3.examStatus==1"
                               class="list_btn list_btn_n">
                            补考已结束
                          </div>

                          <div v-else-if="(item3.ssTime * 1000 >= new Date().getTime() || item3.ssTime == 0) && item3.examStatus!=1"
                               class="list_btn list_btn_n1">
                              在线考试
                          </div>
                          <div v-else-if="item3.ssTimeB * 1000 >= new Date().getTime() && item3.examStatus==1"
                               class="list_btn list_btn_n1">
                            在线补考
                          </div>
                          <div
                                  v-else-if="(item3.ssTime * 1000 <= new Date().getTime()) && (new Date().getTime() <= item3.eeTime * 1000) && item3.is_pass == 0"
                                  class="list_btn2"
                                  @click="toExam(item3.id)"
                                  :class="{ current3: current3 == index3 }"
                                  @mouseenter="current3 = index3"
                                  @mouseleave="current3 = -1"
                          >
                              在线考试
                          </div>
                          <div
                              v-else-if="(new Date().getTime() > item3.eeTime * 1000) && (item3.ssTimeB * 1000 <= new Date().getTime()) && (new Date().getTime() <= item3.eeTimeB * 1000) && item3.examStatus==1"
                              class="list_btn2"
                              @click="toMakeUpExam(item3.id)"
                              :class="{ current3: current3 == index3 }"
                              @mouseenter="current3 = index3"
                              @mouseleave="current3 = -1"
                          >
                            在线补考
                          </div>
                      </div>
<!--                    补考-->
<!--                      <div v-if="new Date().getTime() >= item3.eeTime * 1000 && item3.eeTime != 0 && item3.examStatus==1">-->
<!--                          <div v-if="new Date().getTime() >= item3.eeTimeB * 1000 && item3.eeTimeB != 0"-->
<!--                               class="list_btn list_btn_n">-->
<!--                            补考已结束-->
<!--                          </div>-->
<!--                          <div v-if="item3.ssTimeB * 1000 >= new Date().getTime() || item3.ssTimeB == 0"-->
<!--                               class="list_btn list_btn_n1">-->
<!--                            在线补考-->
<!--                          </div>-->

<!--                          <div-->
<!--                              v-if="item3.is_pass == 1 && item3.btn == 1 && new Date().getTime() < item3.eeTime * 1000"-->
<!--                              class="list_btn"-->
<!--                          >-->
<!--                            已通过-->
<!--                          </div>-->
<!--                          <div-->
<!--                              v-if="(item3.ssTimeB * 1000 <= new Date().getTime()) && (new Date().getTime() <= item3.eeTimeB * 1000)"-->
<!--                              class="list_btn2"-->
<!--                              @click="toMakeUpExam(item3.id)"-->
<!--                              :class="{ current3: current3 == index3 }"-->
<!--                              @mouseenter="current3 = index3"-->
<!--                              @mouseleave="current3 = -1"-->
<!--                          >-->
<!--                            在线补考-->
<!--                          </div>-->
<!--                      </div>-->


                  </div>

                  <div :class="[(item3.totalScore/ 100 ) >= 60 ? 'grades':'grades1']">
                    <span>
                        总成绩
                    </span>
                      <div class="score_link"
                           @click="goDetail(item3)"
                           :class="{ current4: current4 == index3 }"
                           @mouseenter="current4 = index3"
                           @mouseleave="current4 = -1">

                          {{item3.totalScore / 100}}
                      </div>
                  </div>

              </div>
            </div>
            </div>
        </div>
        </div>
        <!-- 遮罩层1-->

        <!-- 打开外层遮罩层 -->
        <el-dialog
                custom-class="dialogOne"
                :visible.sync="centerDialogVisible"
                append-to-body
                width="900px"
                center
        >
            <!-- 遮罩层内容 -->
            <!-- 课堂练习-->
            <div class="bgc">
                <div class="dialogClose dialogClose1" @click="centerDialogVisible = false,flag = true">
                    <i style="cursor: pointer;" class="el-icon-error"></i>
                </div>
                <div>
                    <div v-for="(item2,index2) in exercise">
                        <div style="cursor: pointer;
                                    margin: 0 30px;
                                    height: 118px;
                                    border-bottom: 2px solid #f2f2f2;
                                    justify-content: space-between; display: flex">

                            <div class="info">
                                <div class="title">
                                    {{item2.examName}}
                                </div>
                                <div class="flex rests">
                                    <div>考试时长：{{ item2.allTime }}分钟</div>
                                    <div>剩余考试次数：{{item2.remainingNum}}</div>
                                    <div>历史最高分：{{item2.maxScore}}</div>
                                </div>
                                <div v-if="item2.remainingNum<=0">
                                      <span style="color: red">练习次数已经用完</span>
                                </div>
                            </div>

                            <div class="flex1 right">
                              <div v-if="item2.remainingNum<=0" class="btn btn1">
                                无权限
                              </div>
                                <div v-else class="btn"
                                     @click="goTxt(item2.id)"
                                     :class="{ current2: current2 == index2 }"
                                     @mouseenter="current2 = index2"
                                     @mouseleave="current2 = -1">开始做题
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </el-dialog>

        <!-- 遮罩层2 -->
        <!-- 打开外层遮罩层 -->
        <!-- 在线考试-->
        <el-dialog
                width="900px"
                custom-class="dialogTwo"
                :visible.sync="centerDialogVisible1"
                append-to-body
        >
            <!-- 遮罩层内容 -->
            <div class="bgc">
                <div class="dialogClose dialogClose1" @click="centerDialogVisible1 = false,flag = true">
                    <i style="cursor: pointer;" class="el-icon-error"></i>
                </div>
                <div>
                    <div v-for="(item2,index2) in exercise1">
                        <div style="cursor: pointer;
                                    margin: 0 30px;
                                    height: 118px;
                                    border-bottom: 2px solid #f2f2f2;
                                    justify-content: space-between; display: flex">

                            <div class="info">
                                <div class="title">
                                    {{item2.examName}}
                                </div>
                                <div class="flex rests">
<!--                                    <div style="">题目数量：{{ item2.nums }}道</div>-->
                                    <div>考试时长：{{ item2.allTime }}分钟</div>
                                    <div>剩余考试次数：{{item2.remainingNum}}</div>
                                    <div>历史最高分：{{item2.maxScore}}</div>
                                </div>
                              <div v-if="item2.remainingNum<=0">
                                <span style="color: red">考试次数已经用完</span>
                              </div>
                            </div>
                            <div class="flex1 right">
                                <div v-if="item2.remainingNum<=0 || (item2.eeTime * 1000  <= new Date().getTime()) || (item2.ssTime * 1000  >= new Date().getTime())"
                                     class="btn btn1">
                                  无权限
                                </div>
                                <div v-else class="btn"
                                     @click="goTxt(item2.id)"
                                     :class="{ current2: current2 == index2 }"
                                     @mouseenter="current2 = index2"
                                     @mouseleave="current2 = -1">开始做题
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </el-dialog>

<!--      补考dialog-->
      <el-dialog
          width="900px"
          custom-class="dialogTwo"
          :visible.sync="centerDialogVisible4"
          append-to-body
      >
        <!-- 遮罩层内容 -->
        <div class="bgc">
          <div class="dialogClose dialogClose1" @click="centerDialogVisible4 = false,flag = true">
            <i style="cursor: pointer;" class="el-icon-error"></i>
          </div>
          <div>
            <div v-for="(item2,index2) in exercise2">
              <div style="cursor: pointer;
                                    margin: 0 30px;
                                    height: 118px;
                                    border-bottom: 2px solid #f2f2f2;
                                    justify-content: space-between; display: flex">

                <div class="info">
                  <div class="title">
                    {{item2.examName}}
                  </div>
                  <div class="flex rests">
                    <!--                                    <div style="">题目数量：{{ item2.nums }}道</div>-->
                    <div>考试时长：{{ item2.allTime }}分钟</div>
                    <div>剩余考试次数：{{item2.remainingNum}}</div>
                    <div>历史最高分：{{item2.maxScore}}</div>
                  </div>
                  <div v-if="item2.remainingNum<=0">
                    <span style="color: red">考试次数已经用完</span>
                  </div>
                </div>
                <div class="flex1 right">
                  <div v-if="item2.remainingNum<=0 || (item2.eeTime * 1000  <= new Date().getTime()) || (item2.ssTime * 1000  >= new Date().getTime())"
                       class="btn btn1">
                    无权限
                  </div>
                  <div v-else class="btn"
                       @click="goTxt(item2.id)"
                       :class="{ current2: current2 == index2 }"
                       @mouseenter="current2 = index2"
                       @mouseleave="current2 = -1">开始做题
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </el-dialog>


        <!-- 遮罩层3 -->
        <!-- 打开外层遮罩层 -->
        <el-dialog
                width="900px"
                custom-class="dialogThree"
                :visible.sync="centerDialogVisible2"
                append-to-body
        >
            <div class="bgc" style="padding-left: 25px; font-size: 16px;">
                <div style="padding-top: 25px; ">
                    总成绩 = 在线课程学习 + 课程练习 + 课程考试 + 答疑笔记
                </div>

                <div style="margin-top: 5px">
                    在线课程学习：视频学习（{{ rates.studyRate }}%）
                </div>
                <div style="margin-top: 5px">
                    课程练习：课程测试（{{ rates.practiceRate }}%）
                </div>
                <div style="margin-top: 5px">
                    课程考试：期末考试 （{{ rates.examRate }}%）
                </div>
                <div style="margin-top: 5px">
                    答疑笔记：课程答疑（{{ rates.answerRate }}%）
                </div>

                <div style="margin-top: 5px; color: orangered">
                    及格：在线课程学习+课程练习+课程考试+答疑笔记 ≥ {{
                    popup.rate
                    }}
                    </div>

                <div style="margin-top: 5px">
                    根据每门课程的总学分不同，按照学习情况，实时转化成学分。
                </div>

                <div style="text-align:center; font-size: 22px; margin-top: 10px; color: #ff551b;">
                    {{Now.name}} - 最终成绩
                    </div>
                <div style="margin-top: 5px">
                    在线课程学习：{{Now.videoScore / 100}}
                </div>
                <div style="margin-top: 5px">
                    课程练习：{{Now.practiceScore / 100}}
                </div>
                <div style="margin-top: 5px">
                    课程考试：{{Now.courseScore / 100}}
                </div>
                <div style="margin-top: 5px">
                    答疑笔记：{{Now.answerScore / 100}}
                </div>

                <div style="margin-top: 5px;font-size: 20px">
                    总成绩：{{Now.totalScore / 100}}
                </div>


            </div>

            <span slot="footer" class="dialog-footer">
          <div @click="centerDialogVisible2 = false">确定</div>
        </span>
        </el-dialog>

    </div>
  </div>
</template>

<script>
    import {getHome, uploadVideo, courseExercises,getTerm} from "../assets/js/api.js";
import store from "store";
import Msg from "@/components/msg.vue";
import Bus from "../bus.js";
    import PieChart from "./PieChart"
    import moment from 'moment'
    import BayWindow from "@/components/BayWindow.vue";

export default {
  name: "Home",
  components: {
    Msg,
      PieChart,
    BayWindow
  },
  data() {
    return {
        //水利环境22级第三学期 认识实习（线下课程） 上传成绩，单独显示(成绩暂时显示到site_user sort字段) 弃用
        // userSort:JSON.parse(localStorage.getItem("userInfo")).sort,
    //<div v-if="item3.id==1948" class="score_link">
      //{{userSort}}
    //</div>
    //<div v-else class="score_link"

        ecode:localStorage.getItem("ecode"),
        recordList: [],
        // 开始练习的遮罩层
        exercise: [],
        // 开始考试的遮罩层
        exercise1: [],
        exercise2: [],
        courses: [],
        start_time: undefined,
        end_time: undefined,
        fileList:[],
      imgUrl: "./assets/img/home/bg-1.png",
      // 用户信息
      userInfo: "",
      // 学校信息
      schoolInfo: "",
        terms: [],
      // 教学计划
      semesterList: "",
      // 当前学期
      Now: "",
      nowIndex: 0,
        // 外层遮罩层
        centerDialogVisible: false,
        centerDialogVisible1: false,
        centerDialogVisible3: false,
        centerDialogVisible2: false,
        centerDialogVisible4: false,
        centerDialogVisible9:true,
        // 内层遮罩层
        innerVisible: false,
        innerVisible1: false,
      more: -1,
      active2: 0,
      current: -1,
        current2: -1,
        current3: -1,
        current4: -1,
      Etitle: "当前学期课程：",
      titNum: 2 / 5,
      lists: [], //轮播中的文字
      planList: [],
      // 公告列表
      noticeList: [],
      notice_img: "",
      // echarts数据
      across: [],
      information: [],
        titles:"",
      // 学习说明 弹框数据
      popup: {
        title: "",
        total: 0,
        rate: 0,
      },
        rates:"",
        screenWidth:document.body.clientWidth
    };
  },
    created() {
        this.getHome();
    },
  mounted() {
    const that =this
    window.onresize =() =>{
        return (() =>{
            window.screenWidth = document.body.clientWidth
            that.screenWidth = window.screenWidth
        })
    }

    window.scroll(0, 0);
  },

    watch:{
        screenWidth(val){
            if(!this.timer){
                this.screenWidth = val
                this.timer = true
                let that = this
                setTimeOut(function(){
                    that.timer= false
                },400)
            }
        }
    },
  methods: {
      dateFormat(row, column) {
          var date = row[column.property];
          if (date == undefined) {
              return "";
          }
          return moment(date * 1000).format("YYYY-MM-DD HH:mm:ss");
      },

      format(percentage, item) {
          let data = item.learn / item.videos * 100
          return `${parseInt(data)}%`;
      },
    getHome() {
      getHome(localStorage.getItem("siteId"),localStorage.getItem("info")).then((res) => {
        if (res.code == 200) {
            let i = 0
          this.userInfo = res.data;
          localStorage.setItem("users",JSON.stringify(res.data))
          localStorage.setItem("user.sex",res.data.sex)
          this.schoolInfo = res.data.site;
          store.set("bannerImg", res.data.site.frontLogo);
          this.semesterList = res.data.terms;
          this.noticeList = res.data.notices;
            if (!this.noticeList == undefined || !this.noticeList.length <= 0){
                this.lists = res.data.notices[0];
            } else {
                this.lists = "暂无公告！";
            }
            this.terms = res.data.terms;
            if (this.noticeList.length > 3) {
                this.noticeList.length = 3;
          }
          // let semester = this.semesterList[0].myClasss[0].rates;
          this.notice_img = res.data.notice_img;

          // 学习说明
          // this.popup.title = this.semesterList[0].myClasss[0].name;
          // this.popup.total = this.semesterList[0].myClasss[0].score;
          // this.popup.rate = this.semesterList[0].myClasss[0].rate
          // this.rates = this.semesterList[0].myClasss[0].rates
            console.log(this.semesterList);
          // 学习
          var flag = false;
            this.semesterList.forEach((item, index) => {
            if (item.have_in_hand == 2) {
              item.myClasss.forEach((item1) => {
                this.$set(item1, "btn", "2");
              });
            }
            if (item.have_in_hand == 1) {

              this.popup.title = this.semesterList[index].myClasss[0].name;
              this.popup.total = this.semesterList[index].myClasss[0].score;
              this.popup.rate = this.semesterList[index].myClasss[0].rate
              this.rates = this.semesterList[index].myClasss[0].rates

              flag = true;
                i = index
                this.active2 = i
              item.myClasss.forEach((item1) => {
                this.$set(item1, "btn", "1");
              });
            }
            if (item.have_in_hand == 0) {
              item.myClasss.forEach((item1) => {
                this.$set(item1, "btn", "0");
              });
            }
          });
            if(!flag){
              getTerm(localStorage.getItem("info"),localStorage.getItem("siteId"),this.semesterList[0].id).then((res) => {
                if (res.code == 200) {
                  this.start_time = res.data.beginTime;
                  this.end_time = res.data.endTime;
                  this.courses = res.data.myClasss;


                  this.popup.title = res.data.myClasss[0].name;
                  this.popup.total = res.data.myClasss[0].score;
                  this.popup.rate = res.data.myClasss[0].rate
                  this.rates = res.data.myClasss[0].rates


                  if (res.data.have_in_hand == 2) {
                    res.data.myClasss.forEach((item1) => {
                      this.$set(item1, "btn", "2");
                    });
                  }
                  if (res.data.have_in_hand == 1) {
                    i = index
                    this.active2 = i
                    res.data.myClasss.forEach((item1) => {
                      this.$set(item1, "btn", "1");
                    });
                  }
                  if (res.data.have_in_hand == 0) {
                    res.data.myClasss.forEach((item1) => {
                      this.$set(item1, "btn", "0");
                    });
                  }
                }
              })
            }



            console.log(i, "index")
          //暂时注释掉 ；lzf
            this.start_time = res.data.terms[i].beginTime;
            this.end_time = res.data.terms[i].endTime;
            this.courses = res.data.terms[i].myClasss;
            console.log(this.courses, "kecheng")
          Bus.$emit("schoolInfo", this.schoolInfo);
          Bus.$emit("userInfo", this.userInfo);
        }
      });
    },

    changeTabs(i) {
      let termId = this.semesterList[i].id
      console.log("termId===="+termId)

      getTerm(localStorage.getItem("info"),localStorage.getItem("siteId"),termId).then((res) => {
          if (res.code == 200) {
            this.start_time = res.data.beginTime;
            this.end_time = res.data.endTime;
            this.courses = res.data.myClasss;

            if (res.data.have_in_hand == 2) {
              res.data.myClasss.forEach((item1) => {
                this.$set(item1, "btn", "2");
              });
            }
            if (res.data.have_in_hand == 1) {
              // i = index
              // this.active2 = i
              res.data.myClasss.forEach((item1) => {
                this.$set(item1, "btn", "1");
              });
            }
            if (res.data.have_in_hand == 0) {
              res.data.myClasss.forEach((item1) => {
                this.$set(item1, "btn", "0");
              });
            }
          }
      })
      this.active2 = i
      this.nowIndex = i







      // this.active2 = i;
      // this.nowIndex = i;
      //   this.start_time = this.semesterList[i].beginTime;
      //   this.end_time = this.semesterList[i].endTime;
      //   this.courses = this.semesterList[i].myClasss;

    },
      record(e, i, id) {
          this.exercise[i].flag = true;
          makeNotes(localStorage.getItem("siteId"), localStorage.getItem("info"), id).then((res) => {
              if (res.code == 200) {
                  this.exercise[i].recordList = res.data.record;
              } else {
                  this.$message.error(res.msg);
              }
          });
      },
      record1(id) {
          this.flag = false;
          makeNotes(localStorage.getItem("siteId"), localStorage.getItem("info"), id).then((res) => {
              if (res.code == 200) {
                  this.recordList = res.data.record;
              } else {
                  this.$message.error(res.msg);
              }
          });
      },

    //跳转到学习页面
    toVideo(id) {
      // 继续学习
      this.$router.push({
        path: "/video",
        query: {
          id: id,
        },
      });
    },
      // 跳转到课堂练习
      toPractice(id) {
          this.exercise=[]
          this.centerDialogVisible = true;
          courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), 3, id).then((res) => {
              res.data.forEach((item) => {
                  item.flag = false;
                  item.recordList = [];
              });
              this.exercise = res.data;
          });
      },
      // 跳转到考试
      toExam(id) {
          this.centerDialogVisible1 = true;
          courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), 1, id).then((res) => {
              console.log(res, "试题")
              console.log(typeof res.data[0].ssTime)
              console.log(typeof new Date().getTime())
              console.log(res.data[0].eeTime)
              console.log(parseInt(new Date().getTime()) / 1000)


              console.log(res.data[0].eeTime * 1000 <= new Date().getTime())
              this.exercise1 = res.data;
          });
      },
      // 跳转到补考
      toMakeUpExam(id) {
          this.centerDialogVisible4 = true;
          courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), 2, id).then((res) => {
              // res.data.forEach((item) => {
              //     item.flag = false;
              //     item.recordList = [];
              // });
              this.exercise2 = res.data;
          });
      },
// 点击确定 进入试卷页面
      goTxt(id) {
          this.centerDialogVisible = false;
          this.innerVisible = false;
          this.centerDialogVisible1 = false;
          this.innerVisible1 = false;
          this.$router.push({path: "/exam", query: {c_e_id: id}});
      },

      goDetail(item) {
          console.log(item)
          this.centerDialogVisible2 = true
          this.Now = item;
      },

      openExam(id) {
          this.innerVisible = true;
          this.c_e_id = id;
      },
      openExam1(id) {
          this.innerVisible1 = true;
          this.c_e_id = id;

      },
      //跳转至错题解析
      analysis(id) {
          this.$router.push({path: "/analysis", query: {"examId": this.c_e_id, examDoId: id}});
      },
      // 练习 取消 关闭遮罩层
      close() {
          this.innerVisible = false;
      },
      // 考试 取消 关闭遮罩层
      close1() {
          this.innerVisible1 = false;
      },
    // 跳转到消息中心
      toMag(row) {
      this.$router.push({
        path: "/msgDetail",
        query: {
            id: row.id,
        },
      });
    },

  },
};
</script>
<style lang="less" scoped>
/*.home {
    background-image:url("../assets/img/home/img.png");
    width:100%;
    height: 100%;
}*/
.large-text {
  color: red;
  font-size: 14px;
}
.headers-img {
    /*background-image: url("../assets/img/home/img.png");*/
    background-position-x: center;
    background-position-y: top;
    background-size: 100%;
    background-repeat-x: no-repeat;
    background-repeat-y: repeat;
    background-attachment: initial;
    background-origin: initial;
    background-clip: initial;
    background-color: initial;

}

.score /deep/ .el-progress-bar__outer {
    background-color: #cccccc;
}
.plan_tabs::-webkit-scrollbar {
  width: 10px;
  height: 5px;
}
.plan_tabs::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
.plan_tabs::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
.plan_tabs::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}
.plan_tabs::-webkit-scrollbar-corner {
  background: #179a16;
}

.home {
    background-color: #f4f4f4;
    /*background-image: url("../assets/img/login/bg.png") ;*/
    margin-top: 0px !important;
}
.active {
    background-color: #f85415;
    color: #f8f3e8 !important;
}

.active2 {
    background-color: #f25412; //#6fc4f8;
    color: #f8f3e8 !important;
}
.current {
    background-color: #f85415;
    color: #fff !important;
}

.current2 {
    background-color: #f85415;
    color: #fff !important;
}

.current3 {
    background-color: #f85415;
    color: #fff !important;
}

.current4 {
    background-color: #f85415;
    color: #fff !important;
}

/deep/ .el-dialog__headerbtn {
    display: none;
}
/deep/ .el-dialog__header {
    padding: 0;
}
.dialog_tit {
  width: 100%;
  height: 74px;
  line-height: 74px;
    background-color: #ff9511;
  font-size: 30px;
  color: #ffffff;
}
.dialog_desc {
  line-height: 2.5;
}

.dialog-footer {
  div {
    width: 180px;
    height: 50px;
      background: #ff9511;
    border-radius: 25px;
    text-align: center;
    line-height: 50px;
    color: #fff;
    font-size: 20px;
    margin: 0 auto;
    cursor: pointer;
  }
}

.dialogThree {
    .dialog-footer {
        div {
            width: 180px;
            height: 50px;
            background: #ff9511;
            border-radius: 25px;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-size: 20px;
            cursor: pointer;
        }
    }
}
.banner_box {
  width: 100%;
  height: 500px;
  // margin-top: 60px;
  .banner_img {
    width: 100%;
    height: 500px;
  }
}
.content_box {
  width: 1200px;
  margin: 0 auto;

    .intro {
    position: relative;
    height: 465px;
    // display: flex;
    .intro_left {
      position: absolute;
      z-index: 1;
      top: 6%;
      left: 0px;
      width: 674px;
      height: 411px;
      background-color: #fff;
      padding: 25px 30px;
      box-sizing: border-box;
      .intro_name {
        width: 220px;
        height: 60px;
        background: url("../assets/img/home/title-1.png") no-repeat;
        background-size: 100%;
        margin: 0 auto;
        margin-bottom: 20px;
      }
      .intro_desc {
        font-size: 14px;
        color: #333;
        line-height: 2;
        p {
          text-indent: 2em;
        }
      }
    }
    .intro_right {
      position: absolute;
      right: 0;
      img {
        width: 700px;
        height: 465px;
      }
    }
  }
  .personal_info {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    .personal_left {
      width: 603px;
      height: 425px;
      background: url("../assets/img/home/bg-1.png") no-repeat;
      background-size: 100%;
      .personal_tit {
        width: 100%;
        height: 50px;
        background: url("../assets/img/home/bg-2.png") no-repeat;
        background-size: 100%;
        font-size: 1000px;
          color: #ff551b;
        line-height: 50px;
        padding-top: 18px;
        padding-right: 0px;
        padding-bottom: 30px;
        padding-left: 0px;
        box-sizing: border-box;
      }
      .personal_body {
        padding: 0 40px;
        box-sizing: border-box;
        .personal_body_top {
          margin: 50px 0;
          .per_bd_left {
            display: flex;
            color: #fff;
            font-size: 16px;
            .txImg {
              width: 106px;
              height: 106px;
              margin-right: 25px;
              .name {
                font-size: 18px;
              }
              .gender {
                width: 16px;
                height: 16px;
                margin-left: 5px;
              }
              > div {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 5px;
              }
            }
            .info_box {
              line-height: 2.5;
            }
          }
        }
        .info_tips {
          font-size: 16px;
          color: #fff;
        }
        .per_sign {
          width: 523px;
          height: 43px;
          background: #ffffff;
          border-radius: 21px;
          font-size: 16px;
            color: #ff551b;
          text-align: left;
          line-height: 43px;
          padding: 0 25px;
          box-sizing: border-box;
          margin-top: 20px;
        }
      }
    }
    .personal_right {
      width: 587px;
      height: 425px;
      // background-color: pink;
      padding: 15px;
      box-sizing: border-box;
      .nowTerm {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        .learnState {
          cursor: pointer;
        }
        div:nth-child(1) {
          font-size: 20px;
          color: #333;
        }
        div:nth-child(2) {
          font-size: 18px;
          display: flex;
          align-items: center;
          div {
              color: #ff551b !important;
          }
          img {
            width: 18px;
            height: 18px;
            margin-left: 8px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .plan_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 34px;
      margin: 20px 0;
    padding-left: 13px;
    box-sizing: border-box;
    div:nth-child(1) {
      font-size: 20px;
      color: #333;
    }
    div:nth-child(2) {
      font-size: 16px;
      color: #999;
      cursor: pointer;
    }
  }
  .plan {
    .plan_body {
      .plan_tabs {
        display: flex;
        // justify-content: space-between;
        flex-wrap: wrap;
        // overflow-x: scroll;
          border-radius: 10px;
          background-color: #ff6829; //rgba(13, 140, 255, 0.76);
          overflow: auto;
        .tabsitem {

          div:nth-child(1) {
              width: auto;
              padding: 0 21px;
              float: left;
              height: 48px;
              font-size: 16px;
              color: #f8f3e8;
            text-align: center;
              line-height: 48px;
              border-right-width: 1px;
              border-right-style: solid;
              border-right-color: #f85415;
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
          }
          div:nth-child(2) {
            font-size: 14px;
            color: #666666;
            text-align: center;
            margin-top: 5px;
          }
        }
        .tabsitem:nth-child(5n){
          margin-right: 0;
        }
      }
      .plan_list {
          /*display: flex;*/
          /*flex-wrap: wrap;*/
        // justify-content: space-between;
          margin-top: 18px;
          border-top-color: rgb(221, 221, 221);
          border-top-style: solid;
          border-top-width: 1px;
          border-right-color: rgb(221, 221, 221);
          border-right-style: solid;
          border-right-width: 1px;
          border-bottom-color: rgb(221, 221, 221);
          border-bottom-style: solid;
          border-bottom-width: 1px;
          border-left-color: rgb(221, 221, 221);
          border-left-style: solid;
          border-left-width: 1px;
          border-image-source: initial;
          border-image-slice: initial;
          border-image-width: initial;
          border-image-outset: initial;
          border-image-repeat: initial;
        .list_box {
            border-bottom-width: 1px;
            border-bottom-style: solid;
            border-bottom-color: rgb(221, 221, 221);
            list-style-position: initial;
            list-style-image: initial;
            list-style-type: none;
            /*margin-bottom: 70px;*/
            /*// margin-right: 95px;*/
            /*margin-right: 45px;*/
          .listImg {
            // width: 235px;
            width: 210px;
            height: 122px;
            float: left;
            padding: 15px;
            border-radius: 25px;
          }
          .list_right {
            // width: 168px;
              height: 155px;
              border-bottom-width: 1px;
              border-bottom-style: solid;
              border-bottom-color: rgb(221, 221, 221);
              list-style-position: initial;
              list-style-image: initial;
              list-style-type: none;
            .list_tit {
                font-size: 18px;
                width: 500px;
                height: 125px;
                float: left;
                padding: 15px;
                border-right: 1px #ddd solid;
                .t {
                    font-size: 18px;
                    font-family: "微软雅黑";
                    color: #333;
                    font-weight: 400;
                    line-height: 20px;
                    margin-bottom: 10px;
                }
                .b {
                    color: #e67300;
                    margin-top: 40px;
                    height: 40px;
                }
            ;

                .score {
                    display: flex;
                    color: #ff551b;
                    line-height: 16px;
                    margin: 0px;
                    .el-progress {
                        width: 200px;

                    }
                    .el-progress-bar__outer {
                        border-radius: 100px;
                        background-color: #171616;
                        overflow: hidden;
                        position: relative;
                        vertical-align: middle;

                    }
              }
            }
              .study {
                  width: 200px;
                  height: 125px;
                  float: left;
                  padding-top: 20px;
                  padding-left: 90px;
                  padding-bottom: 15px;
                  border-right: 1px #ddd solid;
                  .list_btn {
                      margin-top: 5px;
                      width: 80px;
                      height: 28px;
                      border: 1px solid #ff551b;
                      background: #02cb73;
                      border-radius: 14px;
                      text-align: center;
                      line-height: 28px;
                      color: #fff;
                      font-size: 12px;
                      cursor: pointer;



                  }
                  .list_btn2 {
                      margin-top: 5px;
                      width: 80px;
                      height: 28px;
                      border: 1px solid #ff551b;
                      border-radius: 14px;
                      text-align: center;
                      line-height: 28px;
                      color: #ff551b;
                      font-size: 12px;
                      cursor: pointer;
                  }
                  .list_btn_n {
                      background: #999;
                  }
                  .list_btn_n1 {
                      background: #cccccc;
                  }
              }

              .grades {
                  width: 85px;
                  padding-top: 10px;
                  padding-left: 30px;
                  float: left;
                  background: url("../assets/img/home/pass.png");
                  background-size: 80px;
                  background-repeat: no-repeat;
                  background-position: 30px;
                  background-position-y: 45px;


                  span {
                      text-align: center;
                      display: block;
                      line-height: 50px;
                      font-family: "微软雅黑";
                      color: #ff551b;
                  }
                  .score_link {
                      text-align: center;
                      display: block;
                      line-height: 50px;
                      font-family: "微软雅黑";
                      font-size: 30px;
                      color: #525252;

                  }
              }
              .grades1 {
                  width: 85px;
                  padding-top: 10px;
                  padding-left: 30px;
                  float: left;
                  background: url("../assets/img/home/wpass.png");
                  background-size: 80px;
                  background-repeat: no-repeat;
                  background-position: 30px;
                  background-position-y: 45px;

                  span {
                      text-align: center;
                      display: block;
                      line-height: 50px;
                      font-family: "微软雅黑";
                      color: #ff551b;
                  }
                  .score_link {
                      text-align: center;
                      display: block;
                      line-height: 50px;
                      font-family: "微软雅黑";
                      font-size: 30px;
                      color: #525252;

                  }
              }

          }
        }
        .list_box:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
  .msg_box {
    .msg_body {
      display: flex;
      margin-bottom: 60px;
      .msg_left {
        width: 454px;
        height: 284px;
        // background-color: #0199ff;
        margin-right: 35px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .msg_right {
        width: 710px;
        .rt_list {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          font-size: 18px;
          height: 50px;
          color: #333;
          > div:nth-child(1) {
            display: flex;
            cursor: pointer;
          }
          img {
            width: 27px;
            height: 23px;
            margin-right: 10px;
          }
          .time {
            color: #999;
          }
        }
      }
    }

  }
}

//遮罩层
.dialogClose {
    position: relative;
    width: 100%;
    height: 30px;
    i {
        position: absolute;
        right: 20px;
        top: 0px;
        font-size: 30px;
        color: #4195f2;
    }
}

.diaTitle {
    text-align: center;
    color: #ff551b;
    font-size: 30px;
}

.Exercise {
    margin-top: 50px;
    margin-bottom: 50px;
    display: flex;
    justify-content: space-around;
}

.exerciseItem {
    position: relative;
    width: 303px;
    height: 344px;
    color: #fff;
    background: linear-gradient(90deg, #8555ff 0%, #b591ff 100%);
    box-shadow: 0px 7px 16px 0px rgba(88, 42, 197, 0.44);
    border-radius: 10px;
    &:nth-child(2) {
        background: linear-gradient(90deg, #6f70fe 0%, #9d9dff 100%);
        box-shadow: 0px 7px 16px 0px rgba(255, 117, 29, 0.3);
    }
    &:nth-child(3) {
        background: linear-gradient(90deg, #ff973c 0%, #68cbff 100%);
        box-shadow: 0px 7px 16px 0px rgba(255, 85, 27, 0.44);
    }
}

.itemIcon {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 25px;
    height: 22px;
    cursor: pointer;
}

.kong {
    height: 20px;
}

.exerciseTop {
    height: 100px;
    text-align: center;
    .exerciseNum {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: bold;
    }
    .exerciseLogo {
        width: 46px;
        height: 47px;
        margin-right: 20px;
    }
    .explain {
        margin-top: 15px;
        margin-bottom: 15px;
    }
}

.exerciseBottom {
    margin-left: 25px;
    margin-right: 25px;
    .line {
        height: 1px;
        opacity: 0.3;
        background-color: #ffffff;
    }
    // 练习封面
    .btmItem {
        display: flex;
        flex-wrap: wrap;
        div {
            margin-top: 15px;
            width: 50%;
        }
    }
    // 做题记录
    .btmItem1 {
        margin-top: 10px;
        height: 140px;
        overflow-x: hidden; /* 解决左右可以滑动的问题 */
        overflow-y: auto;
        .recordItem {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
            div {
                margin-right: 10px;
            }
        }
    }
    // 暂无做题记录
    .without {
        text-align: center;
        padding-top: 40px;
    }
}

// 修改滚动条样式
div::-webkit-scrollbar {
    width: 4px;
    height: 5px;
}

div::-webkit-scrollbar-track {
    background: rgba(191, 191, 191, 0.2);
    border-radius: 4px;
}

div::-webkit-scrollbar-thumb {
    background: #fff;
    border-radius: 4px;
}

.one::-webkit-scrollbar {
    width: 4px;
    height: 5px;
}

.one::-webkit-scrollbar-track {
    background: rgba(191, 191, 191, 0.4);
    border-radius: 4px;
}

.one::-webkit-scrollbar-thumb {
    background: rgba(191, 191, 191, 0.6);
    border-radius: 4px;
}

.diaBtn {
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translateX(-50%);
    display: inline-block;
    width: 112px;
    height: 38px;
    line-height: 38px;
    background-color: rgba(255, 255, 255, 0.4);
    color: #fff;
    border-radius: 19px;
    text-align: center;
    cursor: pointer;
}

.diaBtn1 {
    background-color: #fff;
    color: #ff6e39;
}

.tip {
    font-size: 14px;
    text-align: center;
    color: #ff6e39;
}

// 内部遮罩层
/deep/ .el-dialog__footer {
    margin-bottom: 30px;
}

.dialogThree /deep/ .el-dialog__footer {
    margin-top: 50px;
    margin-bottom: 30px;
}

/deep/ .dialogOne {
    border-radius: 15px;
    overflow: hidden;
}

.con {
    margin: 30px 0;
    color: #333;
    font-size: 22px;
    font-weight: 500;
}

.interiorFooter {
    display: flex;
    height: 80px;
    line-height: 30px;
    cursor: pointer;
    div {
        width: 80px;
        font-size: 18px;
        text-align: center;
        color: #ff6e39;
    }
    .btn {
        background-color: #f8f3e8;
        color: #ff6e39;
    }
}
/deep/ .dialogTwo {
    border-radius: 16px;
}

/deep/ .dialogTwo .el-dialog__body {
    padding: 0;
}

/deep/ .dialogTwo-inside {
    border-radius: 16px;
    overflow: hidden;
}

/deep/ .dialogTwo-inside .el-dialog__body {
    padding: 0 20px;
}

.bgc {
    height: 380px;
    /*background-image: url("../assets/img/study/exam/bg_1_9.png");*/
    background-repeat: no-repeat;
    .info {
        margin-top: 15px;
        margin-left: 20px;
        .title {
            font-size: 18px;
            font-weight: 500;
            color: #333333;
        }

        .rests {
            margin-top: 20px;
            font-size: 12px;
            color: #999999;
            div {
                margin-right: 35px;
            }
        }
    }
    .right {
        margin-right: 20px;
        .btn {
            margin-left: 50px;
            margin-top: 45px;
            margin-bottom: 15px;
            text-align: center;
            width: 100px;
            height: 36px;
            line-height: 36px;
            border: 1px solid #ff551b;
            border-radius: 18px;
            color: #ff551b;
        }

        .btn1 {
            background-color: #f8f8f5;
            color: #a49173;
            border: 1px solid #aeaba9;
        }
        .look {
            font-weight: bold;
            color: #666666;
        }
    }
}

// 遮罩层2
.dialogClose1 {
    height: 45px;
    margin-bottom: 10px;
    i {
        margin-top: 15px;
        color: #ff551b;
    }
}





</style>
